import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeTextarea extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
    default = '';
}
